import type { ReactNode } from 'react';

interface Props {
  id?: string;
  /** Верхний отступ: 'lg' = 44px (первая секция после счётчиков), 'sm' = 8px (все прочие). */
  top: 'lg' | 'sm';
  className?: string;
  children: ReactNode;
}

/**
 * Общий ритм секций лендинга.
 *
 * В макетах `section{padding:60px 0}` — глобальное правило, и отдельные
 * секции переопределяют только ВЕРХНИЙ отступ (`style="padding-top:8px"` или
 * `44px` для первой секции после счётчиков). `/start` в первой версии
 * переносил только переопределение и молча терял унаследованный нижний
 * отступ — из-за этого секции слипались друг с другом. `pb-[60px]` здесь —
 * это и есть тот унаследованный отступ, не декоративная деталь.
 */
export function LandingSection({ id, top, className = '', children }: Props) {
  const topCls = top === 'lg' ? 'pt-11' : 'pt-2';
  return (
    <section id={id} className={`pb-[60px] ${topCls} ${className}`.trim()}>
      <div className="mx-auto max-w-[1120px] px-5">{children}</div>
    </section>
  );
}
